import { filterInvalidQuestions } from './dynamicDpsUtils';

export const mapRecommendations = (
    recommendations = [],
    isFeatured,
) =>
    recommendations.map((recommendation) => {
        const customRecommendation = {
            title: recommendation.name,
            content: recommendation.productDesc,
            sellingPoints: recommendation.sellingPoints,
            isFeatured: isFeatured || false,
            buttons: [],
        };
        if (recommendation.applyUrl) {
            customRecommendation.buttons.push({
                text: 'Apply now',
                url: recommendation.applyUrl,
                variant: 'secondary',
                target: '_blank',
            });
        }
        if (recommendation.learnMore) {
            customRecommendation.buttons.push({
                text: 'Learn more',
                url: recommendation.learnMore,
                variant: 'primary',
                target: '_blank',
            });
        }
        return customRecommendation;
    });

export const sortRecommendationAlphabetically = (a, b) => {
    if (a.name < b.name) {
        return -1;
    }
    if (a.name > b.name) {
        return 1;
    }
    return 0;
};

export const mapRecommendationQuestionRequest = (
    questionnaireState,
) => {
    const mappedQuestionnaire = questionnaireState.map(
        (questionState) => {
            const question = {
                questionId: questionState.id,
                answers: [{ id: questionState.currentAnswer }],
            };
            return question;
        },
    );
    const validQuestionnaire = filterInvalidQuestions(
        mappedQuestionnaire,
    );
    return validQuestionnaire;
};
